var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fetching)?_c('loader'):_c('tabs',{key:_vm.customerId,attrs:{"container-classes":[ 'panel', 'panel-transparent' ],"nav-classes":['nav-tabs-fillup'],"store-module":_vm.moduleName}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74aa4f1b","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Customers/Customer.vue
// module id = 1938
// module chunks = 0